import { render, staticRenderFns } from "./input-normal.vue?vue&type=template&id=10832bbe"
import script from "./input-normal.vue?vue&type=script&lang=js"
export * from "./input-normal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports